import axios from "../../rest.config";
import { Credentials } from "vue/types/vue";

class AdminServiceImpl {
    async getAllPuzzles() {
        const response = await axios().get("/api/v1/admin/get/all/puzzles");

        return response.data;
    }

    async registerUser(payload: Credentials): Promise<boolean> {
        const response = await axios().post("/api/v1/admin/register", payload);
        return response.status === 200;
    }

    async getAllUsers(): Promise<Array<any>> {

        const response = await axios().get("/api/v1/admin/get/all/users")

        return response.data;

    }

    async deleteUser(userid: string): Promise<void> {
        const response = await axios().delete("/api/v1/admin/delete/user", { params: { userid: userid } });

    }

}

export const AdminService = new AdminServiceImpl();